<template>
  <el-container class="full-height">
      <el-main class="page-content">
          <el-main class="container">
              <Nav>
                  <div slot="left">
                        <div class="search-box">
                            <el-input placeholder="请输入用户昵称/手机号搜索" v-model.trim="inputVal" clearable></el-input>
                            <el-button type="primary" style="margin-left: 30px" @click="handleSearch">搜索</el-button>
                        </div>
                  </div>
              </Nav>

              <div class="table-box">
                  <Table
                    border
                    align="center"
                    :header-row-style="{height: '100px'}"
                    :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
                    :row-style="{height: '150px'}"
                    :column="tableData.column"
                    :data="tableData.data"
                    pagination
                    background
                    :paginationTop="'30px'"
                    :paginationAlign="'center'"
                    layout="prev, pager, next, sizes, jumper"
                    :page-sizes="[5, 10, 20, 30]"
                    :pager-count="5"
                    :current-page.sync="body.pageIndex"
                    :total="tableData.total"
                    :page-size="body.pageSize"
                    @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange"
                >
                </Table>
              </div>
          </el-main>
      </el-main>

    <el-dialog :visible.sync="showImgDialog" width="40%">
        <el-image :src="previewImgUlr" fit="scale-down" lazy style="margin: 20px auto;">
        </el-image>
    </el-dialog>
  </el-container>
</template>

<script>
import {
    getFeedBackList,
    finshFeedBack
} from '@/api/complaint.js'
export default {
    data(){
        return{
            previewImgUlr: '',
            showImgDialog: false,
            inputVal: '',
            tableData: {
                total: 0,
                column: [
                    {
                        prop: 'createTime',
                        label: '提交时间'
                    },
                    {
                        prop: 'userName',
                        label: '用户昵称'
                    },
                    {
                        prop: 'mobile',
                        label: '用户手机号'
                    },
                    {
                        prop: 'content',
                        label: '投诉内容'
                    },
                    {
                        label: '图片',
                        width: 500,
                        render: (h, {row}) =>{
                            let html = ''
                            return row.pictureList.map((item, i) =>{
                                return h('img', {
                                    domProps: {
                                        src: `${window.$imgUrl}${row.pictureList[i]}`
                                    },
                                    style: {
                                        width: '100px',
                                        height: '100px',
                                        marginRight: '15px',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.previewImg(item)
                                        }
                                    }
                                })
                            })
                        }
                    },
                    {
                        label: '状态',
                        render: (h, {row}) =>{
                            let { isRead } = row
                            let text = ''
                            if(isRead === 0){
                                text = '未读'
                            } else if(isRead === 1){
                                text = '已读'
                            }
                            return <div>{text}</div>
                        }
                    },
                    {
                        label: '操作',
                        render: (h, {row}) => {
                            if(row.isRead === 0){
                                return (
                                <el-link underline={false} type='primary' onClick={() => { this.handleShow(row) }}>已读</el-link>
                                )
                            } else {
                                return <div></div>
                            }
                            
                        }
                    },
                ],
                data: []
            },
            body: {
                pageSize: 10,
                pageIndex: 1,
                word: ''
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.network().getFeedBackList();
        },
        network(){
            return{
                getFeedBackList: async () =>{
                    let { data } = await getFeedBackList(this.body)
                    this.tableData.data = data.list
                    this.tableData.total = parseInt(data.total)
                },
                finshFeedBack: async (id) =>{
                    await finshFeedBack(id)
                    this.$message.success('成功')
                    this.network().getFeedBackList()
                }
            }
        },
        handleSearch(){
            this.body.word = this.inputVal
            this.network().getFeedBackList()
        },
        handleSizeChange(size){
            this.body.pageSize = size
            this.body.pageIndex = 1
            this.network().getFeedBackList()
        },
        handleCurrentChange(page){
            this.body.pageIndex = page
            this.network().getFeedBackList()
        },
        handleShow(row){
            this.network().finshFeedBack(row.uuid)
        },
        previewImg(item){
            this.showImgDialog = true,
            this.previewImgUlr = `${window.$imgUrl}${item}`
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  border-radius: 15px;
  text-align: center;
}
</style>